import React from 'react';
export function Header() {
  return <header className="flex flex-col items-center border-b border-gray-200 pb-4 px-4 md:px-0" data-id="element-197">
      <div className="py-6 max-w-3xl w-full flex flex-col items-center" data-id="element-198">
        <div className="w-64 mb-1" data-id="element-199">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vouEN7zbkJynvYCiidXx73/f5594340-91f8-4a89-9b65-afa6f3a246b4_optimized.png" alt="MA|40 MUSCLE AFTER 40" className="w-full h-auto" data-id="element-200" />
        </div>
        <p className="text-center text-sm text-gray-500" data-id="element-201">
          Your guide to fitness, health, and wellness
        </p>
      </div>
    </header>;
}